<template>
  <div v-if="visible" class="d-inline-block" @click.stop>
    <v-tooltip bottom max-width="240">
      <template #activator="{ on }">
        <!-- ya vinculado: ícono discreto, no pide atención -->
        <v-btn
          v-if="isLinked"
          icon
          x-small
          class="mr-2"
          v-on="on"
          @click.stop="open"
        >
          <v-icon small color="grey">mdi-link-variant</v-icon>
        </v-btn>
        <!-- pendiente: botón con texto -->
        <v-chip
          v-else
          x-small
          label
          dark
          class="mr-2"
          :color="color"
          v-on="on"
          @click.stop="open"
        >
          <v-icon x-small left>mdi-account-multiple-outline</v-icon>
          Coincidencias
        </v-chip>
      </template>
      <span>{{ tooltip }}</span>
    </v-tooltip>
    <LeadMatchesModal
      v-if="opened"
      :dialog.sync="dialog"
      :lead-id="lead._id"
      @linked="$emit('linked')"
    />
  </div>
</template>

<script>
export default {
  components: {
    LeadMatchesModal: () =>
      import("@/components/lead/components/LeadMatchesModal.vue")
  },
  props: {
    lead: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return { dialog: false, opened: false };
  },
  methods: {
    open() {
      this.opened = true;
      this.dialog = true;
    }
  },
  computed: {
    // pertenece a un contacto (expediente)
    isLinked() {
      return !!this.lead.unified_contact_id;
    },
    match() {
      return this.isLinked ? null : this.lead.contact_match;
    },
    // Coincidencias: solo con contact_grouping 'on' (si la config no está
    // disponible, p. ej. coordinator, basta el campo del lead)
    visible() {
      const group = this.$store.state.realEstateGroup?.realEstateGroup;
      if (group && group.contact_grouping !== "on") return false;
      return !!(this.lead._id && (this.isLinked || this.match));
    },
    color() {
      return this.match && this.match.level === "exact"
        ? "orange darken-2"
        : "grey darken-1";
    },
    tooltip() {
      if (this.isLinked) return "Pertenece a un contacto. Ver registros.";
      const level = this.match.level === "exact" ? "exacta" : "parcial";
      return `Coincidencia ${level} con otro registro. Abrir para revisar o vincular.`;
    }
  }
};
</script>
